import React, { useContext, useEffect, useState } from 'react';

import { actionContext } from "../../apps/page";
import ErrorVendorCheck from "../../util/ErrorVendoreCheck";
import { SlotImageInterface } from "../../data/gameData_slot";
import { CasinoImageInterface, otherCasino } from "../../data/gameData_casino";

import icon from "../../_asset/image/icon.png"
import { loadingContext } from "../provider/game_loading_provider";
import { gameType, lobbyModalContext, vendorSum } from "../provider/lobby_modal_provider";
import AudioPlayer from "../layout/audio_player";
import swal from "sweetalert";
import SectionHeader from '../layout/section_header';
import casino_bg from '../../_asset/casino/casino_bg.png';
import casino_bg_hover from '../../_asset/casino/casino_bg_hover.png';
import images from '../../util/imageLoader';

type gameItemsClassType = "" | "disabled" | "focus"
export type gameTypes = "casino" | "slot"

export default function GameList({ title, type, list }:
    { title: string, type: gameTypes, list: CasinoImageInterface[] | SlotImageInterface[] }) {
    const { User, SetLoginPop } = useContext(actionContext)

    const [oneFocus, setOneFocus] = useState(false)

    return (
        <div className={'game-list'}>
            <SectionHeader sectionType={type} />
            <div className={`game-items-wrap ${type}`}
                onMouseOut={e => setOneFocus(false)}
            >
                {
                    list?.map((obj, index) => {
                        return (
                            <GameItems key={index}
                                index={index}
                                obj={obj}
                                type={type}
                                isLogin={User?.is_authenticated ? true : false}
                                SetLoginPop={SetLoginPop}
                                setOneFocus={setOneFocus}
                                isOneFocus={oneFocus} />
                        )
                    })
                }
            </div>
        </div>
    );
}


export function GameItems({ obj, index, type, isLogin, SetLoginPop, setOneFocus, isOneFocus }:
    {
        obj: vendorSum,
        index: number,
        type: gameTypes
        isLogin: boolean,
        SetLoginPop: Function,
        setOneFocus: Function,
        isOneFocus: boolean
    }) {
    const [focus, setFocus] = useState<boolean>(false)
    const [state, setState] = useState<gameItemsClassType>("")
    const [audioPlay, setAudioPlay] = useState<boolean>(false)

    const [girl1, setGirl1] = useState<string>(images[0])
    const [girl2, setGirl2] = useState<string>(images[1])

    const { SetLoadingPop } = useContext(loadingContext)
    const { SetLobbyShow, SetVendorInfo, SetType } = useContext(lobbyModalContext)

    useEffect(() => {
        if (isOneFocus && focus) {
            // mouseover
            setState('focus')
        } else if (isOneFocus && !focus) {
            // other items
            setState('disabled')
        } else {
            setState('')
        }
    }, [focus, isOneFocus])

    useEffect(() => {
        const start = index * 2 + 1;
        setGirl1(images[start + 1])
        setGirl2(images[start + 2])
    }, [index])
    return (
        <div className={`game-items ${state}`}
            onClick={e => {
                if (isLogin) {
                    if (['popok', 'Nolimit City'].includes(obj.vendor)) {
                        swal({
                            text: '점검중 입니다.',
                            icon: 'warning'
                        })
                    } else if (obj.vendor == 'Booongo') {
                        window.open(`/gameLobby/Booongo/?uid=bng_mini_lobby&vendor=Booongo`,
                            `$Booongo`, `width=1200 height=640`)
                    } else if (obj.vendor == 'MicroGaming Plus Slo') {
                        window.open(`/gameLobby/MicroGaming Plus Slo/?vendor=MicroGaming%20Plus%20Slo&uid=falconlobby`,
                            `$MicroGaming Plus Slo`, `width=1200 height=640`)
                    } else {
                        SetLobbyShow()
                        SetVendorInfo(obj)
                        SetType(type)
                    }

                    // if(type == 'slot' || otherCasino.includes(obj.vendor)){
                    //     SetLobbyShow()
                    //     SetVendor(obj.vendor)
                    //     SetType('slot')
                    // }else{
                    //     SetLoadingPop(true)
                    //     ErrorVendorCheck(obj.vendor, obj.id, type)
                    //         .finally(()=> SetLoadingPop(false))
                    // }
                } else {
                    SetLoginPop()
                }
            }}
            onMouseOver={e => {
                setAudioPlay(true)
                setFocus(true)
                setOneFocus(true)
            }}
            onMouseOut={e => {
                setAudioPlay(false)
                setFocus(false)
            }}
        >
            {
                type == "casino"

                    ?
                    <div className='casino-item' >
                        <img src={casino_bg_hover} alt="bg" className='bg-hover' />
                        <img src={casino_bg} alt="bg" className='bg' />
                        <img src={girl1} alt="girl left" className='girl left' />
                        <img src={girl2} alt="girl right" className='girl right' />
                        <div className={'company-name'}>
                            <img src={obj.logo} alt="" className='company-logo' />
                            <p>
                                <span className='text'>{obj.name}</span>
                                <span className='shadow-text'>{obj.name}</span>
                            </p>
                        </div>
                    </div>
                    :
                    <div className="slot-card">
                        <div className="slot-item">
                            <div className="slot-thumb">
                                <img src={obj.img} alt={obj.name} />

                            </div>
                            <div className="slot-brand">
                                <img src={obj.logo} alt={obj.name} title={obj.vendor} className="brand-logo" />
                                {/* <span className="brand-name">{obj.name}</span> */}
                            </div>
                        </div>
                        <div className="slot-title">
                            {/* <span style={{ fontSize: "16px" }} className="brand-name">{obj.name}</span> */}
                            {obj.name}
                        </div>
                    </div>
            }
            <AudioPlayer type={"company"} play={audioPlay} />
        </div>
    )
}

